export default __webpack_public_path__ + "static/media/lock.427bfd36.svg";